export default __webpack_public_path__ + "static/atos-31a4952568825e0f13a494f0c5ba4388.svg";